<h1>Lager / Warenbestände</h1>

<mat-nav-list>
  <a mat-list-item routerLink="/stockmanaging/warehouse">Lager</a>
  <a mat-list-item routerLink="/stockmanaging/stocks">Warenbestände</a>
  <a mat-list-item routerLink="/stockmanaging/settings">Einstellungen</a>
</mat-nav-list>

<router-outlet></router-outlet>
